<template>
  <div class="serial-field">
    <v-text-field
      :value="value"
      :label="label"
      :hint="hint"
      :error-messages="messages"
      :disabled="disabled"
      prepend-inner-icon="mdi-identifier"
      outlined
      maxlength="100"
      autocomplete="off"
      autocapitalize="characters"
      spellcheck="false"
      @input="onInput"
      @blur="checkTyped"
    >
      <template #append>
        <v-btn
          small
          depressed
          class="serial-field__scan"
          :disabled="disabled"
          aria-label="Scanează seria cu camera sau dintr-o fotografie"
          @click="scanner = true"
        >
          <v-icon left small>mdi-qrcode-scan</v-icon>Scanează
        </v-btn>
      </template>
    </v-text-field>
    <BarcodeScanner v-model="scanner" title="Scanează seria" @scanned="onScanned" />
  </div>
</template>

<script>
// Seria of an item: typed, or read from its barcode / QR / DataMatrix („Scanează”: live camera on https, „Din fotografie”
// everywhere). Wi-Fi codes, links and the Suport sticker are refused (decoder.rejectReason, same rule as the server);
// scanned EAN / UPC product numbers too (scanner only: typed text has no format).
import BarcodeScanner from "@/components/scan/BarcodeScanner.vue";
import { rejectReason } from "@/components/scan/decoder";

export default {
  name: "SerialField",
  components: { BarcodeScanner },
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "Seria (opțional)" },
    // e.g. the server's „Seria X este deja înregistrată: ...”
    errorMessages: { type: [String, Array], default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { scanner: false, localError: "", scannedValue: "" };
  },
  computed: {
    messages() {
      const outer = Array.isArray(this.errorMessages) ? this.errorMessages : [this.errorMessages];
      return [this.localError, ...outer].filter(Boolean);
    },
    hint() {
      if (this.scannedValue && this.scannedValue === this.value) return "Citită cu camera. Verificați că este seria (S/N), nu alt cod.";
      return "S/N de pe eticheta echipamentului; nu este nr. de inventar";
    },
  },
  methods: {
    onInput(text) {
      this.localError = "";
      this.$emit("input", text || "");
    },
    onScanned(text) {
      this.localError = "";
      this.scannedValue = text;
      this.$emit("input", text);
      this.$emit("scanned", text);
    },
    checkTyped() {
      const text = String(this.value || "").trim();
      this.localError = text ? rejectReason(text) : "";
    },
    // for the dialogs' validateForm(): '' when the value may be saved
    validate() {
      this.checkTyped();
      return this.localError;
    },
  },
};
</script>

<style scoped>
.serial-field ::v-deep .v-input__append-inner {
  margin-top: 10px !important;
}
.v-application .serial-field__scan.v-btn {
  background-color: var(--green) !important;
  color: #fff !important;
  height: 36px !important;
}
.v-application .serial-field__scan.v-btn .v-icon {
  color: #fff !important;
}
</style>
